import { LocaleLanguages } from "@boark/shared/types/locale-languages";

import { formatNumber } from "./number";

export const formatPrice = (
  price: number,
  locale: LocaleLanguages = "sv",
  format: "SEK" = "SEK",
) => {
  const value = formatNumber(price, " ", locale === "sv" ? "," : ".");
  return formatters[format](value);
};

const formatters = {
  SEK: (value: string) => `${value} kr`,
};
